export const XR_RENDER_SCALE = [0.5, 0.75, 0.8, 1, 1.25, 1.5, 2]